import { Component, Input, OnInit } from "@angular/core";
import { PinnedItem } from "../pinned-models";
import { PinnedService } from "../pinned.service";
import { PinnedModels } from "../pinned-models";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { EmailContentComponent } from "src/app/dashboard/email/email-content/email-content.component";
import { GenericDrawerService } from "src/app/dashboard/drawer/global-drawer.service";
import { Firestore } from "@angular/fire/firestore";
import { ConversationsService } from "src/app/dashboard/conversations/conversations.service";
import { WorkspacesService } from "../../workspaces.service";
import { Router } from "@angular/router";
import { SharedDataService } from "src/app/dashboard/shared-data.service";

import { MomentModule } from "ngx-moment";
import { EmailCardComponent } from "../../../../email/email-card/email-card.component";
import { TrackedItemBubbleComponent } from "../../../../conversations/tracked-item-bubble/tracked-item-bubble.component";
import { JobsAndTasksCardComponent } from "../../jobs-and-tasks/jobs-and-tasks-card/jobs-and-tasks-card.component";
import { NoteCardComponent } from "../../notes/note-card/note-card.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";
@Component({
  selector: "app-pinned-card",
  templateUrl: "./pinned-card.component.html",
  styleUrls: ["./pinned-card.component.scss"],
  imports: [
    TooltipModule,
    NoteCardComponent,
    JobsAndTasksCardComponent,
    TrackedItemBubbleComponent,
    EmailCardComponent,
    MomentModule,
    PinComponent,
  ],
})
export class PinnedCardComponent implements OnInit {
  private _pinnedItem: PinnedItem;

  @Input() set pinnedItem(value: PinnedItem) {
    this._pinnedItem = value;
    switch (value.model_name) {
      case PinnedModels.Note:
        this.pk = "uuid";
        break;
      default:
        this.pk = "id";
    }
  }

  get pinnedItem(): PinnedItem {
    return this._pinnedItem;
  }

  @Input() disableClick: boolean = false;
  @Input() clientCompanyId: number = null;

  pk: string;
  PinnedModels = PinnedModels;
  PinnedMessage = PinnedModels.Message;

  @Input() messageDebug: boolean = false;

  constructor(
    private dashboardStore: DashboardStore,
    private genericDrawerService: GenericDrawerService,
    private workspacesService: WorkspacesService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private sharedDataService: SharedDataService
  ) {}

  getClientCompany(): any {
    if (this.pinnedItem?.client_company) {
      return this.dashboardStore.clients.find(
        ({ uuid }) => uuid === this.pinnedItem.client_company
      );
    }
    return null;
  }

  ngOnInit(): void {}

  selectThread() {
    this.genericDrawerService.changeComponent(EmailContentComponent, {
      thread: this.pinnedItem.content_object,
    });
  }

  selectJob() {
    this.dashboardStore._selectJob.next(this.pinnedItem.content_object);
  }

  selectMessage() {
    const currentPath = this.clientCompanyId
      ? `/practice/workspaces/${this.clientCompanyId}/jobs`
      : this.router.url;

    const newPath =
      currentPath.substring(0, currentPath.lastIndexOf("/")) + "/conversations";

    if (this.clientCompanyId != null) {
      this.localStorageService.set("last_workspace", this.clientCompanyId);
    }

    setTimeout(() => {
      this.router.navigate([newPath]);
    }, 200);

    this.workspacesService.switchActiveTab.next({
      tab: "conversations",
      payload: {},
    });

    this.dashboardStore.selectMessage$.next(this.pinnedItem.content_object);
  }
}
